// extracted by mini-css-extract-plugin
module.exports =  {"popup-container":"popup-container-xTEk4","header":"header-JEoGO","title":"title-NbYXB","badge":"badge-cXEXi","frame":"frame-YGbvx"};